<template>
  <div
    class="modal fade"
    id="inputConfirmModal"
    role="dialog"
    aria-labelledby="inputConfirmModalLabel"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="inputConfirmModalLabel">{{ titleText }}</h5>
          <button
            v-if="btnCloseText"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form onSubmit="return false;">
            <div class="form-group">
              <label for="input-name" class="col-form-label">{{ inputCaptionText }}</label
              >
              <input
                required
                autofocus
                type="text"
                class="form-control"
                id="input-name"
                :placeholder="inputHintText"
                v-model="inputText"
                @keyup.enter="onConfirm" />
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button v-if="btnCloseText" type="button" class="btn btn-secondary" data-dismiss="modal">{{ btnCloseText }}</button>
          <button type="button" class="btn btn-primary" @click="onConfirm">{{ btnConfirmText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import $ from 'jquery'

export default {
  props: {
    titleText: { type: String, default: () => { return null; }},
    inputCaptionText: { type: String, default: () => { return null; }},
    inputHintText: { type: String, default: () => { return null; }},
    btnCloseText: { type: String, default: () => { return null }},
    btnConfirmText: { type: String, default: () => { return 'Confirm'; }},
  },
  data: () => ({
    inputText: null
  }),
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    onShowModal: function() {
      $("#inputConfirmModal").modal('show')
    },
    onHideModal: function() {
      $("#inputConfirmModal").modal('hide')
    },
    onConfirm: function () {
      this.$emit('onConfirm', this.inputText)
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>

</style>
